module.exports = __webpack_public_path__ + "img/数据中心背景dark.b831d2b0.png";